import React from 'react';
import _ from 'lodash';
import moment from 'moment';
import { Tag } from 'antd';
import { CrownFilled } from '@ant-design/icons';

/** DON'T EDIT THESE FUNCTION */
export const displayIsActive = (value, t) => {
  let displayStr = '';
  let tagColor = 'green';
  let statusValue = _.toInteger(value);
  switch (statusValue) {
    case 1:
      displayStr = "common.active";
      tagColor = 'green';
      break;
    case 0:
      displayStr = "common.inactive";
      tagColor = 'red';
      break;
    case -1:
      displayStr = "common.disabled";
      tagColor = '#9A9A9A';
      break;
    default:
      displayStr = "common.error"
      tagColor = '#f50';
      break;
  }
  return <Tag color={tagColor}>{t(displayStr)} </Tag>;
}

export const displayDataTime = (unix) => {
  if(unix == null){
    return "---";
  }else{
    return <span>{moment.unix(unix).format('YYYY-MM-DD')}</span>;
  }
}

export const displayMoment = (unixTime, outputFormat = 'YYYY/MM/DD HH:mm') => {
  if (unixTime !== 0) {
      let displayTime = moment.unix(unixTime).format(outputFormat);
      return displayTime;
  }
  return '-';
}

export const displayOrderStatus = (value, t) => {
  const keys = [
    "normal",
    "driver_taken",
    "user_confirmed",
    "finished",
    "cancelled_by_user",
    "cancelled_by_driver",
    "cancelled_by_driver_and_back_to_pool",
    "timeout",
    "others"
  ];

  let statusValue = value < 0 || value >= keys.length ? keys.length-1: value;
  let finalKey = 'order_status.' + keys[statusValue];

  return <Tag>{t(finalKey)} </Tag>;
}

export const displayOrderType = (value, t) => {
  const keys = [
    "call_cars_now",
    "book_cars",
    "Unknown"
  ];

  let statusValue = value < 0 || value >= keys.length ? keys.length-1: value;
  let finalKey = 'order_type.' + keys[statusValue];

  return <Tag>{t(finalKey)} </Tag>;
}

export const displayVehicleType = (value) => {
  if (value === null) return <Tag />;

  let str = '';
  let tagColor = '';
  let statusValue = _.toInteger(value);
  switch (statusValue) {
      case 0:
          str = "新界的士 NT Taxi";
          tagColor = 'green';
          break;
      case 1:
          str = "市區的士 Urban Taxi";
          tagColor = 'red';
          break;
      case 2:
          str = "大嶼山的士 Lantau Taxi";
          tagColor = 'lightblue';
          break;
      default:
          break;
  }

  return <Tag color={tagColor}>{str}</Tag>;
}

/** BELOW FUNCTION CAN BE EDITABLE */
export const displayPermission = (permission_lv, t) => {
  let hidden = true;
  let color = "grey";
  let value = "Unknown";

  switch (permission_lv) {
    case 3:
      value = 'member_vip';
      color = "red";
      hidden = false;
      break;
    case 2:
      value = 'member_adv';
      color = "green";
      hidden = false;
      break;
    // case 1:
    //   value = "Basic";
    //   break;
    default:
      // value = "No Permission";
      value = 'member_basic';
  }

  return <span>
    <CrownFilled 
      style={{
        "display": (hidden ? "none" : null),
        "color": color
      }}/> 
    {t(value)} 
  </span>;
}

export const displayQuestStatus = (value, t) => {
  let displayStr = '';
  let tagColor = 'green';
  let statusValue = _.toInteger(value);

  switch (statusValue) {
    case 1:
      displayStr = "scheduled"
      tagColor = 'green';
      break;
    case 0:
      displayStr = "non_scheduled"
      tagColor = 'red';
      break;
    case -1:
      displayStr = "posted";
      tagColor = '#9A9A9A';
      break;
    default:
      displayStr = "error"
      tagColor = '#f50';
      break;
  }
  return <Tag color={tagColor}> {t(displayStr)} </Tag>;
}

export const displaySolveStatus = (value, t) => {
  let displayStr = '';
  let tagColor = 'green';
  let statusValue = _.toInteger(value);
  
  switch (statusValue) {
    case 0:
      displayStr = "fixing";
      tagColor = 'green';
      break;
    case 1:
      displayStr = "solved";
      tagColor = 'grey';
      break;
    default:
      displayStr = "unsolve"
      tagColor = '#f50';
      break;
  }
  return <Tag color={tagColor}>{t(displayStr)} </Tag>;
}

export const displayTargetMembership = (value, t) => {
  let targetLevel = "no_prefer_target";
  let textGrey = true;
  let crownColor = "none";

  switch(value){
    case 1:
      targetLevel = "member_basic";
      textGrey = false;
      break;
    case 2: 
      targetLevel = "member_adv";
      textGrey = false;
      crownColor = "green";
      break;
    case 3: 
      targetLevel = "member_vip"
      textGrey = false;
      crownColor = "red";
      break;
  }

  return (
    <span>
      <CrownFilled style={{color: crownColor}} /> {t(targetLevel)}
    </span>
  )
}

export const displayEventStatus = (status, t) => {
  let displayStr = '';
  let tagColor = 'green';
  let statusValue = _.toInteger(status);

  switch (statusValue) {
    case 1:
      displayStr = "in_use";
      tagColor = 'green';
      break;
    case 0:
      displayStr = "finished";
      tagColor = 'red';
      break;
    case -1:
      displayStr = "delayed";
      tagColor = '#9A9A9A';
      break;
    default:
      displayStr = "error"
      tagColor = '#f50';
      break;
  }
  return <Tag color={tagColor}> {t(displayStr)} </Tag>;
}

export const displayInviteStatus = (status, t) => {
  let displayStr = '';
  let tagColor = 'green';
  let statusValue = _.toInteger(status);

  switch (statusValue) {
    case 1:
      displayStr = "paid";
      tagColor = 'green';
      break;
    case 0:
      displayStr = "not_pay_yet";
      tagColor = 'red';
      break;
    case 2:
      displayStr = "invited";
      tagColor = 'grey';
      break;
    default:
      displayStr = "error"
      tagColor = '#f50';
      break;
  }

  return <Tag color={tagColor}>{t(displayStr)} </Tag>;
} 

export const displayAdminRole = (value, t) => {
  // TODO: Temp for handle display frst, must be edit
  let v = _.toInteger(value);
  let displayStr = '';
  let tagColor = 'orange';
  switch (v) {
    case 1:
      displayStr = "高級管理人員";
      break;
    case 2:
      displayStr = "普通管理人員";
      break;
    case 3:
      displayStr = "管理人員";
      break;
    default:
      displayStr = "Not Exist Role";
      break;
  }
  return <Tag color={tagColor}>{displayStr}</Tag>;
}

export const displayApproveStatus = (value, t) => {
  let displayStr = '';
  let tagColor = 'green';
  let statusValue = _.toInteger(value);
  
  switch (statusValue) {
    case 1:
      displayStr = "approved";
      tagColor = 'green';
      break;
    case -1:
      displayStr = "reject";
      tagColor = '#9A9A9A';
      break;
    default:
      displayStr = "error"
      tagColor = '#f50';
      break;
  }
  return <Tag color={tagColor}>{t(displayStr)} </Tag>;
}

export const getCascaderList = (data, t) => {
  let list = [];
  Object.keys(data).map((key) => {
    if (key !== "null") {
      let curr = {
        value: key,
        label: t(key)
      };
      // console.log(typeof data[key]);
      if (typeof data[key] == "object" && key != "other") {
        let child_list = [];
        data[key].map((sec_key) => {
          let child = {
            value: sec_key,
            label: t(sec_key)
          };
          child_list.push(child);
        })
        curr.children = child_list;
      }
      list.push(curr);
    }
  })
  if (Object.keys(data).includes("null")) {
    data.null.map((name) => {
      list.push({
        value: name,
        label: t(name)
      });
    })
  }
  return list; 
}